import React from "react";
import { connect } from "react-redux";
import { RootState } from "store/store";
import { getTickerParams } from "store/reducers/FilterSlice";
import { setFilteredColumns } from "store/reducers/quotes";
import TPH from "utils/ticker-params-handler";
import { useAppSelector } from "hooks/redux";




const Updater = ({
    activePage,
    currentTab,

    filter_params,
    getTickerParams,
    active_page_id,
    filtered_columns,
    setFilteredColumns,
    filter_params_order,
    manual_query,
}) => {

    const { selectedRobotId } = useAppSelector(
        (state: RootState) => state.robots,
    );
    const { activeGroupTickers } = useAppSelector((state) => state.groups);
    React.useEffect(() => {
        if (!selectedRobotId) return;
        if (!filter_params) return



            getTickerParams();

    }, [activePage?.id, selectedRobotId,getTickerParams]);

    React.useEffect(() => {
        TPH.dropState();
    }, [activePage?.id]);
    /*
    React.useEffect(() => {
        if (!filter_params_order || !filter_params) {
            return;
        }

        const sorted = filter_params.sort((a, b) => {
            return filter_params_order.indexOf(a.name) - filter_params_order.indexOf(b.name);
        });
        console.log('sorted', sorted);
        setFilterParams(sorted);
    }, [filter_params, filter_params_order]);
*/
    return <></>;
};

export default connect(
    (state: RootState) => ({
        activePage: state.quotesPage.activePage,
        currentTab: state.tabs.currentTab,
        filter_params: state.filter.filterParams,
        active_page_id: state.quotes.active_page_id,
        filtered_columns: state.quotes.filtered_columns,
        filter_params_order: state.filter.filterParamsOrder,
        manual_query: state.filter.manual_query,
    }),
    {

        getTickerParams,
        setFilteredColumns,
    },
)(Updater);
